import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

// 外部css资源
import './assets/plugins/bootstrap/css/bootstrap.min.css';
import './assets/plugins/font-awesome/css/font-awesome.min.css';
import './assets/plugins/icomoon/style.css';
import './assets/plugins/uniform/css/default.css';
import './assets/plugins/switchery/switchery.min.css';
import './assets/plugins/nvd3/nv.d3.min.css';
import './assets/css/ecaps.min.css';
import './assets/css/custom.css';

// 外部js资源

import './assets/plugins/jquery/jquery-3.1.0.min.js';
import './assets/plugins/bootstrap/js/bootstrap.min.js';
import './assets/plugins/jquery-slimscroll/jquery.slimscroll.min.js';
import './assets/plugins/uniform/js/jquery.uniform.standalone.js';
import './assets/plugins/switchery/switchery.min.js';
import './assets/js/ecaps.min.js';

//element Plus UI
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

//CKEditor 5 富文本编辑器
import CKEditor from '@ckeditor/ckeditor5-vue';




const app = createApp(App)

// 全局注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(store).use(router).use(ElementPlus).use(CKEditor).mount('#app')
